function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M474 453H40c-18 0-32-14-32-31V142c0-18 15-31 32-31h97l39-48c7-9 12-14 29-14h104c16 0 23 7 30 14l38 48h97c18 0 32 14 32 31v280c0 18-15 31-32 31zM257 169c-58 0-107 48-107 107 0 58 49 106 107 106 59 0 107-48 107-106 0-59-48-107-107-107z"
}));